import React, { useState, useEffect, useContext, useReducer } from 'react';
import { Card, Input, Progress, Row, Col } from 'antd';
import { useHistory } from 'react-router';
import withSizes from 'react-sizes'
import { SearchOrderItemContext, INITIAL_SET_ORDER_ITEMS, SearchOrderItemReducer } from '../../Contexts/SearchOrderItem/SearchOrderItemContext';

import { TiThMenu } from 'react-icons/ti';
import { MdSearch } from 'react-icons/md';
import searchIcon from '../../assets/svg/Path.svg';
import SearchBar from '../../Components/searchBar/index';
import AvatarPopover from './components/AvatarPopover';
import '../../assets/styles/global.scss';
import './styles/header.scss';

function Header(props) {
    const percent = 67;
    const { navValues, setNavValues } = props;
    const [searchOrder, searchOrderDispatcher] = useReducer(SearchOrderItemReducer, INITIAL_SET_ORDER_ITEMS);
    const history = useHistory();

    return (
        <div className="flex-space-inbetween">
            <div>
                {/* {props.isMobileOrTab && <TiThMenu className="icon-header m-l-5" onClick={() => {
                    let temp = navValues;
                    temp.showNav = !temp.showNav;
                    temp.view = props.isMobileOrTab ? "mobile" : "web";
                    setNavValues(temp);
                }} />} */}
                {/* <SearchOrderItemContext.Provider
                    value={{
                        ...searchOrder,
                        dispatch: searchOrderDispatcher,
                    }}> */}
                {/* <SearchOrderItemContext.Consumer> */}
                {/* {value =>  */}
                <SearchBar searchCtx={{
                    ...searchOrder,
                    dispatch: searchOrderDispatcher,
                }} history={history} />
                {/* </SearchOrderItemContext.Consumer> */}
                {/* </SearchOrderItemContext.Provider> */}
            </div>
            <div className="m-r-10">
                <AvatarPopover />
            </div>
        </div>
    );
}

const mapSizesToProps = ({ width }) => ({
    isMobileOrTab: width < 720,
})

export default withSizes(mapSizesToProps)(Header)
